// Detects a presigned S3 URL whose signature has already expired, so callers
// can fall back to a permanent URL instead of rendering a broken image.
export function isExpiredPresignedUrl(url) {
  if (!url) return false;

  try {
    const parsed = new URL(url);
    const amzDate = parsed.searchParams.get('X-Amz-Date'); // e.g. 20260829T202709Z
    const expiresInStr = parsed.searchParams.get('X-Amz-Expires'); // seconds
    if (!amzDate || !expiresInStr) return false;

    const expiresIn = parseInt(expiresInStr, 10);
    if (!Number.isFinite(expiresIn)) return false;

    const match = amzDate.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/);
    if (!match) return false;

    const [, year, month, day, hour, minute, second] = match;
    const issuedAtMs = Date.UTC(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10),
      parseInt(hour, 10),
      parseInt(minute, 10),
      parseInt(second, 10)
    );

    return Date.now() > issuedAtMs + expiresIn * 1000;
  } catch (e) {
    return false;
  }
}

// Original image URL to use for crop-position rendering, or null when it's
// missing/expired so the caller can fall back to the permanent cropped media_url.
export function getUsableOriginalUrl(draft) {
  const original = draft?.media_url_original;
  if (!original || isExpiredPresignedUrl(original)) return null;
  return original;
}
